// extracted by mini-css-extract-plugin
export default {"label":"_2iTok","icon":"_2JKf2"};